import { Space, Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { formatMassDateTime } from '../../AddMassOfferingUtils';
// eslint-disable-next-line import/no-named-as-default
import ChangeDateButton from '../../ChangeDateButton';
import { NoMassHourTooltip } from '../../../NoMassHourTooltip/NoMassHourTooltip';
import { massPropTypes } from '../../../../propTypes/mass';
import selectors from '../../../../store/selectors';

export const MassDateTime = ({ mass }) => {
  const timeZone = useSelector(selectors.selectTimeZone);
  const massDate = formatMassDateTime(mass, timeZone);

  return (
    <Space direction="vertical" size={0}>
      <Typography.Text>Zamawiasz intencję na:</Typography.Text>
      <Typography.Text strong>
        {massDate} <NoMassHourTooltip mass={mass} /> <ChangeDateButton />
      </Typography.Text>
    </Space>
  );
};

MassDateTime.propTypes = {
  mass: massPropTypes,
};
